// Every lead-system timestamp is stored/computed in UTC on the backend.
// This is the single place that renders them for admins — always in the
// business timezone (Asia/Manila), regardless of the viewer's own browser
// timezone, and always labelled "PHT" so it's never mistaken for local time.
export const formatManilaTime = (iso, { withYear = false } = {}) => {
  if (!iso) return '';
  try {
    const formatted = new Date(iso).toLocaleString('en-US', {
      timeZone: 'Asia/Manila',
      month: 'short',
      day: 'numeric',
      ...(withYear ? { year: 'numeric' } : {}),
      hour: '2-digit',
      minute: '2-digit',
    });
    return `${formatted} PHT`;
  } catch {
    return iso;
  }
};
